module.exports = __webpack_public_path__ + "static/west-mi-fabrication-iso-9001-certificate-2022-c1dd8f5785083952dd0fc3cdac45aa8b.pdf";